<loading-component *ngIf="scope.loading"></loading-component>
<div *ngIf="(scope.suggestions$ | async) as suggestions" disabledDiv>
    <ng-container *ngIf="(suggestions && suggestions.length > 0) else noResults">
        <app-data-card *ngFor="let sugg of suggestions" [shortVersion]="true" [match]="sugg" class="match"></app-data-card>
    </ng-container>
</div>

<ng-template #noResults>
    <p [innerText]="scope.getText | transform:'YOU_HAVE_NO_SUGGESTIONS'"></p>
</ng-template>